import { object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

export const getValidationSchema = () => object().shape({
  name: string().trim().max(255).required(I18n.t('publisher.availability.schedules.text_field_popup.errors.string.blank'))
})
